
import * as z from "zod";
import { useTranslation } from "react-i18next";

export const createTimeSlotSchema = () => {
  const { t } = useTranslation();
  
  return z.object({
    selectedDays: z.array(z.string()).min(1, t("schedule.form.selectDays")),
    workoutTypeId: z.string().min(1, t("schedule.form.selectWorkoutType")),
    startTime: z.string().optional(),
    endTime: z.string().optional(),
    maxClients: z.number().min(1, t("schedule.form.enterMaxClients")),
    autoEndTime: z.boolean().default(false),
    isRecurringMode: z.boolean().default(false),
    recurringStartTime: z.string().optional(),
    recurringEndTime: z.string().optional(),
    recurringInterval: z.string().optional(),
    slotDuration: z.string().optional(),
  }).refine((data) => {
    if (data.isRecurringMode) {
      // When in recurring mode, validate recurring fields
      return (
        data.recurringStartTime && 
        data.recurringEndTime && 
        data.recurringInterval && 
        data.slotDuration
      );
    } else {
      // When not in recurring mode, validate regular time fields
      return data.startTime && data.endTime;
    }
  }, {
    message: "Please fill in all required time fields",
    path: ["startTime"], // This will show the error on the time fields
  });
};

export type TimeSlotFormData = z.infer<ReturnType<typeof createTimeSlotSchema>>;
